/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1InfluencerId202,
  PutApiV1InfluencerId400,
  PutApiV1InfluencerId401,
  PutApiV1InfluencerId404,
  PutApiV1InfluencerId500,
  PutApiV1InfluencerIdMutationRequest,
  PutApiV1InfluencerIdMutationResponse,
  PutApiV1InfluencerIdPathParams,
} from "../../types/influencerRegistroController/PutApiV1InfluencerId.ts";
import { influencerViewModelSchema } from "../influencerViewModelSchema.ts";
import { updateInfluencerRequestViewModelSchema } from "../updateInfluencerRequestViewModelSchema.ts";

export const putApiV1InfluencerIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1InfluencerIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1InfluencerId202Schema = z.lazy(
  () => influencerViewModelSchema,
) as unknown as ToZod<PutApiV1InfluencerId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1InfluencerId400Schema =
  z.any() as unknown as ToZod<PutApiV1InfluencerId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1InfluencerId401Schema =
  z.any() as unknown as ToZod<PutApiV1InfluencerId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1InfluencerId404Schema =
  z.any() as unknown as ToZod<PutApiV1InfluencerId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1InfluencerId500Schema =
  z.any() as unknown as ToZod<PutApiV1InfluencerId500>;

export const putApiV1InfluencerIdMutationRequestSchema = z.lazy(
  () => updateInfluencerRequestViewModelSchema,
) as unknown as ToZod<PutApiV1InfluencerIdMutationRequest>;

export const putApiV1InfluencerIdMutationResponseSchema = z.lazy(
  () => putApiV1InfluencerId202Schema,
) as unknown as ToZod<PutApiV1InfluencerIdMutationResponse>;
